import React from "react";
import ReactApexChart from "react-apexcharts";

// Helper function to group data by month
const groupDataByMonth = (data) => {
    const monthlyData = Array(12).fill(null).map(() => ({
        TotalCreated: 0,
        TotalSold: 0,
        TotalSoldPrice: 0,
    }));

    data.forEach((item) => {
        const month = new Date(item.actionTimestamp).getMonth(); // Extract month (0-11)
        monthlyData[month].TotalCreated += item.totalCreated || 0;
        monthlyData[month].TotalSold += item.totalSold || 0;
        monthlyData[month].TotalSoldPrice += item.totalSoldPrice || 0;
    });

    return monthlyData;
};

const YearOverviewChart = ({ data }) => {
    // Process data to get grouped data by month
    const monthlyData = groupDataByMonth(data);

    const series = [
        {
            name: "Dodano",
            type: "bar",
            data: monthlyData.map((item) => item.TotalCreated),
        },
        {
            name: "Vrijednost",
            type: "line",
            data: monthlyData.map((item) => item.TotalSoldPrice / 1000),
        },
        {
            name: "Prodano",
            type: "bar",
            data: monthlyData.map((item) => item.TotalSold),
        }
    ];

    const options = {
        chart: {
            height: 374,
            type: "line",
            toolbar: {
                show: false,
            },
        },
        stroke: {
            curve: "smooth",
            dashArray: [0, 3, 0],
            width: [0, 1, 0],
        },
        fill: {
            opacity: [1, 0.1, 1],
        },
        markers: {
            size: [0, 4, 0],
            strokeWidth: 2,
            hover: {
                size: 6,
            },
        },
        xaxis: {
            categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            axisTicks: {
                show: false,
            },
            axisBorder: {
                show: false,
            },
        },
        yaxis: {
            labels: {
                formatter: (value) => value.toFixed(0)
            },
        },
        grid: {
            show: true,
            xaxis: {
                lines: {
                    show: true,
                },
            },
            yaxis: {
                lines: {
                    show: false,
                },
            },
            padding: {
                top: 0,
                right: -2,
                bottom: 15,
                left: 10,
            },
        },
        legend: {
            show: true,
            horizontalAlign: "center",
            offsetX: 0,
            offsetY: -5,
            markers: {
                width: 10,
                height: 10,
                radius: 6,
            },
            itemMargin: {
                horizontal: 10,
                vertical: 0,
            },
        },
        colors: ["#28a745", "#007bff", "#0DCAF0"],
        tooltip: {
            shared: true,
            y: [
                {
                    formatter: function (y) {
                        return y ? y.toFixed(0) : 0;
                    },
                },
                {
                    formatter: function (y) {
                        return y ? y.toFixed(1) + "k KM" : "0 KM";
                    },
                },
                {
                    formatter: function (y) {
                        return y ? y.toFixed(0) : 0;
                    },
                }
            ],
        },
        plotOptions: {
            bar: {
                columnWidth: "30%",
                barHeight: "70%"
            },
        },
    };

    return (
        <React.Fragment>
            <ReactApexChart
                dir="ltr"
                options={options}
                series={series}
                type="line"
                height="374"
                className="apex-charts"
            />
        </React.Fragment>
    );
};

export default YearOverviewChart;